import axios from "../../axios";
import { useEffect, useState } from "react";
import ModalViewComponent from "../Shared Components/modalView";

export default function PhonePePaymentComponent() {
  const [redirectURLForFailure, setRedirectURLForFailure] = useState("");
  const [paymentConfirmTitle, setPaymentConfirmTitle] = useState();
  const [message, setMessage] = useState();
  const [extra, setExtra] = useState();
  const [redirectURL, setRedirectURL] = useState();
  const [successFlag, setSuccessFlag] = useState();
  const [buttonText, setButtonText] = useState();
  const [isPaymentDone, setIsPaymentDone] = useState(false);

  const getCurrentPageUrl = () => {
    const url = new URL(window.location.href);
    return url?.origin + url?.pathname;
  };

  const handleVerifyPaymentForSuccess = (result) => {
    if (result.data.status === "SUCCESS") {
      setPaymentConfirmTitle("Payment Successfull!!");
      setMessage("Enrollment Confirmed.");
      setExtra(" Click on the button to redirect to the batch page");
      setRedirectURL(result.data.redirect_url);
      setSuccessFlag(true);
      setButtonText("View Batch");
      // successfullPurchaseEvent()
    } else {
      setPaymentConfirmTitle("Payment Un-successfull!!");
      setMessage("Your payment could not be processed.");
      setExtra(
        "Please try after some time. If your account was debited, the amount will be refunded within a week."
      );
      setRedirectURLForFailure(getCurrentPageUrl());
      setSuccessFlag(false);
    }
    setIsPaymentDone(true);
  };

  const handleVerifyPaymentForFailure = () => {
    setPaymentConfirmTitle("Payment Un-successfull!!");
    setMessage("Your payment could not be processed.");
    setExtra(
      "Please try after some time. If your account was debited, the amount will be refunded within a week."
    );
    setRedirectURLForFailure(getCurrentPageUrl());
    setSuccessFlag(false);
    setIsPaymentDone(true);
  };

  async function handlePhonePePaymentVerfication() {
    const currentPageUrl = window.location.href;

    const tempParams = {
      gateway: "phone_pe",
      page_url: currentPageUrl,
    };

    const currentPageQueryParams = Object.fromEntries(
      new URL(currentPageUrl).searchParams
    );
    if (
      currentPageQueryParams?.["type"] === "verify" &&
      currentPageUrl.includes("/payments")
    ) {
      const data = { ...tempParams, ...currentPageQueryParams };
      await axios
        .post(`payment/verify-payment/`, data)
        .then((res) => {
          handleVerifyPaymentForSuccess(res);
        })
        .catch((error) => {
          handleVerifyPaymentForFailure();
        });
    } else if (currentPageQueryParams?.["type"] === "payment-failed") {
      handleVerifyPaymentForFailure();
    }
  }

  useEffect(() => {
    handlePhonePePaymentVerfication();
  }, []);

  return (
    <div>
      {isPaymentDone ? (
        <ModalViewComponent
          title={paymentConfirmTitle}
          message={message}
          extra={extra}
          redirect_url={redirectURL}
          success_flag={successFlag}
          button_text={buttonText}
          failure_redirect_url={redirectURLForFailure}
        />
      ) : (
        ""
      )}
    </div>
  );
}
